import {IUtility, Utility} from "../helpers/utils/utility";
import {Config, IConfig} from "../helpers/configuration/config";
import {Constants}  from "../helpers/configuration/constants";
import {ToastType} from "../helpers/toasttype";

interface IParentView { 
    utility: IUtility;
    config: IConfig;
    constants: Constants;
    btnSaveId: string;
    formId: string; 
}
abstract class ParentView implements IParentView{
    utility: IUtility;
    config: IConfig;
    constants: Constants;
    btnSaveId: string ;
    formId: string; 
    protected constructor(formId:string, btnSaveId:string){
        this.utility = new Utility();
        this.config= new Config();
        this.constants= new Constants();
        this.formId=formId;
        this.btnSaveId=btnSaveId;
    }
    AddSaveButtonClickForValidation() {
        let btnSave: HTMLButtonElement = <HTMLButtonElement>(document.getElementById(this.btnSaveId) as HTMLButtonElement);
        if (btnSave) {
            let obj = this;
            //console.log('AddSaveButtonClickForValidation: Button found, adding click handler');
            btnSave!.addEventListener("click", function (event) {
                // Always prevent default first, then decide whether to submit
                event.preventDefault();
                //console.log('Button clicked, calling ValidateForm for:', obj.formId);
                
                try {
                    if (obj.utility.ValidateForm(obj.formId)) {
                       // console.log('Validation passed - submitting form');
                        obj.utility.sayToast("Saving Data!");
                        // Submit the form programmatically
                        const form = document.getElementById(obj.formId) as HTMLFormElement;
                        if (form) {
                            form.submit();
                        }
                    }
                    else {
                        //console.log('Validation failed - form not submitted');
                        obj.utility.sayToast("Please correct Errors!", ToastType.Error);
                    }
                } catch (error) {
                    //console.error('Error in ValidateForm:', error);
                    obj.utility.sayToast("Validation error occurred", ToastType.Error);
                }
            });
        }
        else {
            //console.log('AddSaveButtonClickForValidation: Button not found:', this.btnSaveId);
        }
    }
}
export { ParentView, IParentView}
